import {css} from '@logistics-frontend/blocks/theme/css'
import {makeStyles} from '@logistics-frontend/blocks/theme/UNSTABLE_makeStyles'

const classes = {
  iframe: css`
    inline-size: 100%;
    border: none;
  `,
  modal: css``,
}

export type ClassKey = keyof typeof classes
export const useClasses = makeStyles(classes)
